/**
 * UUID v4 idempotency key for claim submit/resubmit. Single source for the
 * codebase; the old version at pages/Claims/utils/idempotencyKey.js is
 * deleted in Plan B8.
 */
function getCrypto() {
  // window covers browser + JSDOM. CRA's eslint config bans `globalThis` and
  // `self` (no-restricted-globals), so we don't probe worker contexts here —
  // worker code that needs idempotency keys can pass crypto in explicitly.
  if (typeof window !== 'undefined' && window.crypto) return window.crypto;
  return undefined;
}

function randomBytes(/** @type {number} */ n) {
  const cryptoObj = getCrypto();
  if (typeof cryptoObj?.getRandomValues === 'function') {
    const out = new Uint8Array(n);
    cryptoObj.getRandomValues(out);
    return out;
  }
  const out = new Uint8Array(n);
  for (let i = 0; i < n; i += 1) out[i] = Math.floor(Math.random() * 256);
  return out;
}

function uuidV4FromBytes() {
  const b = randomBytes(16);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const hex = Array.from(b, (v) => v.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function makeIdempotencyKey() {
  const cryptoObj = getCrypto();
  if (typeof cryptoObj?.randomUUID === 'function') {
    try { return cryptoObj.randomUUID(); } catch { /* fall through */ }
  }
  return uuidV4FromBytes();
}
